import React from 'react';
import { SectionEyebrow } from './SectionEyebrow';
import { Reveal } from './Reveal';
import { GridRails } from './GridRails';
import { snapshot } from '../data/home';

/** Executive overview + strategic snapshot. */
export function AboutIntro() {
  return <section id="about" className="relative bg-mist-bg text-ink" data-id="element-15" data-mp="2a8b96lwd0br7">
      <GridRails data-id="element-16" data-mp="2e691vypc9fzc" />
      <div className="relative z-10 mx-auto max-w-[1720px] px-9 pb-[64px] pt-[48px] md:px-24 md:py-[140px] lg:px-32" data-id="element-17" data-mp="2e6r73ktzb4je">
        <Reveal data-id="element-18" data-mp="1hjmdx3hzj0nd">
          <SectionEyebrow label="ABOUT" data-id="element-19" data-mp="1mg32fyt3jh0z" />
          <p className="mt-[22px] max-w-[1080px] font-display text-[26px] leading-[1.13] tracking-[-0.015em] md:text-[32px]" data-id="element-20" data-mp="1mgwf1geql0r1">
            KAYS & KAYS is a Dubai-registered family office ecosystem. Founded and architected by Adrian Kays, it operates not as a traditional wealth manager, but as an infrastructure of optimal conditions for Culture, Capital and Longevity.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-8 md:mt-[100px] md:grid-cols-[1fr_1.4fr] md:gap-16" data-id="element-21" data-mp="36umxk7syg07q">
          <Reveal data-id="element-22" data-mp="2iov18wia6buv">
            <p className="max-w-[400px] text-[14.5px] leading-[1.5] text-ink/65" data-id="element-23" data-mp="2ipeg24cmwk4o">
              By removing tactical noise and focusing on recursive quality, we create a self-reinforcing ecosystem
              where financial assets, media reach and human performance continuously compound one another.
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-24" data-mp="1zr1xxt3qvzwy">
            <dl className="border-t border-mist-line" data-id="element-25" data-mp="1zs3jwsmau6tg">
              {snapshot.map(row => <div key={row.label} className="grid gap-1 border-b border-mist-line py-5 sm:grid-cols-[200px_1fr] sm:gap-8" data-id="element-26" data-mp="1uzk3lnw88xky">
                  <dt className="font-accent text-[11px] uppercase tracking-[0.08em] text-ink/55 sm:pt-[3px]" data-id="element-27" data-mp="1l2xkb3jjuel1">
                    {row.label}
                  </dt>
                  <dd className="text-[15px] leading-[1.45] text-ink/85" data-id="element-28" data-mp="1g55j1ix0lg46">{row.value}</dd>
                </div>)}
            </dl>
          </Reveal>
        </div>
      </div>
    </section>;
}